const type = {
  // Data Fetching
  FETCH_CLOUD_VPC_DEVICES: "FETCH_CLOUD_VPC_DEVICES",
  SET_VPC_DEVICE_DATA: "SET_VPC_DEVICE_DATA",

  // CRUD Operations
  ADD_CLOUD_VPC: "ADD_CLOUD_VPC",
  EDIT_CLOUD_VPC: "EDIT_CLOUD_VPC",
  DELETE_CLOUD_VPC: "DELETE_CLOUD_VPC",

  // UI & Modal State
  CLOSE_OPEN_MODEL: "CLOSE_OPEN_MODEL",
  SET_VPC_CREATE_FLAG: "SET_VPC_CREATE_FLAG",
  SET_VPC_DEVICE_ERROR: "SET_VPC_DEVICE_ERROR",
  VPC_LOADER: "VPC_LOADER",

  // Scheduler/Sync Data
  GET_VPC_SCHEDULER_DATA: "GET_VPC_SCHEDULER_DATA",
};

export default type;
